import React from 'react';
import Room from '../../../features/room/Room';
import { useApplicationCallbacks } from '../../../../providers/application-callbacks';

const StartRoom = React.forwardRef(function (_, ref) {
  const callbacks = useApplicationCallbacks();

  return (
    <div className={'start__room-wrapper'}>
      <Room callbacks={callbacks} />
    </div>
  );
});
export default StartRoom;
